// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomizeOrganizationSettings-module__dsAccented--Ezm8s,.CustomizeOrganizationSettings-module__dsAccented--Ezm8s *{font-weight:500}.CustomizeOrganizationSettings-module__dsDefaultWeight--DhtQX,.CustomizeOrganizationSettings-module__dsDefaultWeight--DhtQX *{font-weight:400}h5.CustomizeOrganizationSettings-module__dsAccented--Ezm8s,h5.CustomizeOrganizationSettings-module__dsAccented--Ezm8s *{font-weight:700}.CustomizeOrganizationSettings-module__dsUnderline--yzSzb,.CustomizeOrganizationSettings-module__dsUnderline--yzSzb *{text-decoration:underline}.CustomizeOrganizationSettings-module__dsAccented2--ntfWo,.CustomizeOrganizationSettings-module__dsAccented2--ntfWo *{font-weight:700}.CustomizeOrganizationSettings-module__dsBodyXL--u5tcg,.CustomizeOrganizationSettings-module__dsBodyXL--u5tcg *{font-size:18px;line-height:27px}.CustomizeOrganizationSettings-module__dsBodyLarge--PEl6S,.CustomizeOrganizationSettings-module__dsBodyLarge--PEl6S *{font-size:16px;line-height:24px}.CustomizeOrganizationSettings-module__dsBody--LfDRt,.CustomizeOrganizationSettings-module__dsBody--LfDRt *{font-size:14px;line-height:20px}.CustomizeOrganizationSettings-module__dsBodySmall--fgMuk,.CustomizeOrganizationSettings-module__dsBodySmall--fgMuk *{font-size:12px;line-height:18px}.CustomizeOrganizationSettings-module__dsBodyXS--LOA0y,.CustomizeOrganizationSettings-module__dsBodyXS--LOA0y *{font-size:10px;line-height:15px}.CustomizeOrganizationSettings-module__dsActionLarge--tqMAm,.CustomizeOrganizationSettings-module__dsActionLarge--tqMAm *{font-size:16px;line-height:18px}.CustomizeOrganizationSettings-module__dsAction--KNOIw,.CustomizeOrganizationSettings-module__dsAction--KNOIw *{font-size:14px;line-height:16px}.CustomizeOrganizationSettings-module__dsActionSmall--X2KNN,.CustomizeOrganizationSettings-module__dsActionSmall--X2KNN *{font-size:12px;line-height:14px}.CustomizeOrganizationSettings-module__dsColumnHeadLine--iJO8W,.CustomizeOrganizationSettings-module__dsColumnHeadLine--iJO8W *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.CustomizeOrganizationSettings-module__dsLightXL--mycDq,.CustomizeOrganizationSettings-module__dsLightXL--mycDq *{font-size:120px;line-height:160px;font-weight:300}.CustomizeOrganizationSettings-module__dsLightLarge--dZh4G,.CustomizeOrganizationSettings-module__dsLightLarge--dZh4G *{font-size:48px;line-height:64px;font-weight:300}.CustomizeOrganizationSettings-module__dsLight--qemDM,.CustomizeOrganizationSettings-module__dsLight--qemDM *{font-size:32px;line-height:64px;font-weight:300}.CustomizeOrganizationSettings-module__dsLightSmall--NqOOe,.CustomizeOrganizationSettings-module__dsLightSmall--NqOOe *{font-size:24px;line-height:36px;font-weight:300}.CustomizeOrganizationSettings-module__dsLightXS--A4J2w,.CustomizeOrganizationSettings-module__dsLightXS--A4J2w *{font-size:18px;line-height:27px;font-weight:300}.CustomizeOrganizationSettings-module__organizationSettingsContainer--yq0Eo{max-width:650px}.CustomizeOrganizationSettings-module__organizationSettingsToggleLabel--DFRGE{font-weight:400;font-size:14px;margin-top:-5px;display:block;color:var(--gray-6);cursor:pointer}.CustomizeOrganizationSettings-module__organizationSettingsToggleText--BfS4H{line-height:18px;font-size:12px;display:block;color:var(--gray-5)}.CustomizeOrganizationSettings-module__disconnectButton--jgxxY{display:block;margin-top:16px}.CustomizeOrganizationSettings-module__manageSecretsPopoverPaper--IReBU{width:600px}.CustomizeOrganizationSettings-module__manageSecretsPopoverPaper--IReBU .basic-modal-footer{display:flex;flex-direction:row;justify-content:flex-end;align-items:center;gap:12px;margin-top:12px;margin-left:auto}.CustomizeOrganizationSettings-module__manageSecretsPopoverPaper--IReBU .basic-modal-footer .basic-modal-footer-button{flex-shrink:0}.CustomizeOrganizationSettings-module__secretsModalContentWrapper--WNlbv{height:420px;overflow-x:hidden;overflow-y:auto}.CustomizeOrganizationSettings-module__fields-list--bXsCY{display:flex;flex-direction:column;gap:8px}.CustomizeOrganizationSettings-module__fields-list-item--oI2n2{display:flex;align-items:stretch;width:100%}.CustomizeOrganizationSettings-module__fields-list-inputs--dkrCF{display:flex;flex-grow:1;gap:8px;width:92%}.CustomizeOrganizationSettings-module__fieldInput--ZEHWs{flex-grow:1;height:36px}.CustomizeOrganizationSettings-module__removeButtonWrapper--bJkIT .CustomizeOrganizationSettings-module__removeButton--YdDBF{display:flex;justify-content:center;align-items:center;min-width:16px;width:16px;height:16px;border-radius:50%;overflow:hidden;padding:0;margin:auto;color:#b3b9c8;cursor:pointer}.CustomizeOrganizationSettings-module__titleWrapper--iJeDU{width:195px}.CustomizeOrganizationSettings-module__removeButton--YdDBF:disabled{color:#ccc;cursor:not-allowed;pointer-events:auto}.CustomizeOrganizationSettings-module__fieldWrapper--kKXYT{margin-bottom:8px}.CustomizeOrganizationSettings-module__fieldInputWrapper--b5qg4{flex-grow:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `CustomizeOrganizationSettings-module__dsAccented--Ezm8s`,
	"dsDefaultWeight": `CustomizeOrganizationSettings-module__dsDefaultWeight--DhtQX`,
	"dsUnderline": `CustomizeOrganizationSettings-module__dsUnderline--yzSzb`,
	"dsAccented2": `CustomizeOrganizationSettings-module__dsAccented2--ntfWo`,
	"dsBodyXL": `CustomizeOrganizationSettings-module__dsBodyXL--u5tcg`,
	"dsBodyLarge": `CustomizeOrganizationSettings-module__dsBodyLarge--PEl6S`,
	"dsBody": `CustomizeOrganizationSettings-module__dsBody--LfDRt`,
	"dsBodySmall": `CustomizeOrganizationSettings-module__dsBodySmall--fgMuk`,
	"dsBodyXS": `CustomizeOrganizationSettings-module__dsBodyXS--LOA0y`,
	"dsActionLarge": `CustomizeOrganizationSettings-module__dsActionLarge--tqMAm`,
	"dsAction": `CustomizeOrganizationSettings-module__dsAction--KNOIw`,
	"dsActionSmall": `CustomizeOrganizationSettings-module__dsActionSmall--X2KNN`,
	"dsColumnHeadLine": `CustomizeOrganizationSettings-module__dsColumnHeadLine--iJO8W`,
	"dsLightXL": `CustomizeOrganizationSettings-module__dsLightXL--mycDq`,
	"dsLightLarge": `CustomizeOrganizationSettings-module__dsLightLarge--dZh4G`,
	"dsLight": `CustomizeOrganizationSettings-module__dsLight--qemDM`,
	"dsLightSmall": `CustomizeOrganizationSettings-module__dsLightSmall--NqOOe`,
	"dsLightXS": `CustomizeOrganizationSettings-module__dsLightXS--A4J2w`,
	"organizationSettingsContainer": `CustomizeOrganizationSettings-module__organizationSettingsContainer--yq0Eo`,
	"organizationSettingsToggleLabel": `CustomizeOrganizationSettings-module__organizationSettingsToggleLabel--DFRGE`,
	"organizationSettingsToggleText": `CustomizeOrganizationSettings-module__organizationSettingsToggleText--BfS4H`,
	"disconnectButton": `CustomizeOrganizationSettings-module__disconnectButton--jgxxY`,
	"manageSecretsPopoverPaper": `CustomizeOrganizationSettings-module__manageSecretsPopoverPaper--IReBU`,
	"secretsModalContentWrapper": `CustomizeOrganizationSettings-module__secretsModalContentWrapper--WNlbv`,
	"fields-list": `CustomizeOrganizationSettings-module__fields-list--bXsCY`,
	"fields-list-item": `CustomizeOrganizationSettings-module__fields-list-item--oI2n2`,
	"fields-list-inputs": `CustomizeOrganizationSettings-module__fields-list-inputs--dkrCF`,
	"fieldInput": `CustomizeOrganizationSettings-module__fieldInput--ZEHWs`,
	"removeButtonWrapper": `CustomizeOrganizationSettings-module__removeButtonWrapper--bJkIT`,
	"removeButton": `CustomizeOrganizationSettings-module__removeButton--YdDBF`,
	"titleWrapper": `CustomizeOrganizationSettings-module__titleWrapper--iJeDU`,
	"fieldWrapper": `CustomizeOrganizationSettings-module__fieldWrapper--kKXYT`,
	"fieldInputWrapper": `CustomizeOrganizationSettings-module__fieldInputWrapper--b5qg4`
};
module.exports = ___CSS_LOADER_EXPORT___;
